import { Button, DatePicker, Form, Grid, Input, Select } from 'antd';
import { ContentFilters } from 'components';
import { StandardItemsWrapper } from 'components/content-filters/content-filters.styles';
import { useGetMaterialCommonList } from 'features/material-details/use-cases/get-commonmasterlist';
import { useGetRoleTypes } from 'features/users/use-cases/get-roleTypeList';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { EntryLogFilterFormField, EntryLogFilterFormValues } from './type';

const { useBreakpoint } = Grid;
const { RangePicker } = DatePicker;

type VehicleFilterFormProps = {
  formId: string;
  handleFilter: (values: EntryLogFilterFormValues) => void;
  initialValues: EntryLogFilterFormValues;
  closeModal?: () => void;
  onRefresh: () => void;
};

export const VehicleFilterForm = ({
  formId,
  handleFilter,
  initialValues,
  closeModal,
  onRefresh
}: VehicleFilterFormProps) => {
  const [validateTrigger, setValidateTrigger] = useState(['onSubmit']);
  const [form] = Form.useForm<EntryLogFilterFormValues>();
  const { t } = useTranslation();
  const screens = useBreakpoint();
  const { data: roleTypeFilterList, isLoading: roleTypeFilterLoading } = useGetRoleTypes();

  const onReset = () => {
    form.resetFields();
    handleFilter(initialValues);
    onRefresh();
  };

  const onFinish = (formValues: EntryLogFilterFormValues) => {
    handleFilter(formValues);
    closeModal?.();
  };
  const { data: materialDetailType } = useGetMaterialCommonList({
    Flag: "EntryType",
  } as any);
    const { data: VisitStatus } = useGetMaterialCommonList({
    Flag: "VisitStatus",
  } as any);
  if (roleTypeFilterLoading) return null;
  if (!roleTypeFilterList || !Array.isArray(roleTypeFilterList) || roleTypeFilterList.length === 0) {
    return <div>No roles available</div>;
  }

  return (
    <Form<EntryLogFilterFormValues>
      id={formId}
      name={formId}
      className="filters-form"
      form={form}
      layout="vertical"
      onFinish={onFinish}
      initialValues={initialValues}
      onFinishFailed={() => {
        setValidateTrigger(['onChange']);
      }}
      validateTrigger={validateTrigger}
    >
      <ContentFilters.FormItemsWrapper className="cf_frm" style={{ width: '100%' }}>
        <StandardItemsWrapper className="cf_frm_row" style={{ width: '100%' }}>
          <div className="invoice_list" style={{ width: '100%' }}>
            <Form.Item<EntryLogFilterFormValues>
              label="Driver Name"
              name={EntryLogFilterFormField.DriverName}
            >
              <Input placeholder="Enter Driver Name" />
            </Form.Item>

            <Form.Item<EntryLogFilterFormValues>
              label="Vehicle Number"
              name={EntryLogFilterFormField.VehicleNumber}
            >
              <Input placeholder="Enter Vehicle Number" />
            </Form.Item>

            <Form.Item<EntryLogFilterFormValues>
              label="Supplier/Customer Name"
              name={EntryLogFilterFormField.SupplierName}
            >
              <Input placeholder="Supplier/Customer Name" />
            </Form.Item>

            <Form.Item<EntryLogFilterFormValues>
              label="Entry Type"
              name={EntryLogFilterFormField.EntryTypeId}
            >
                <Select
                placeholder="Select Type"
                options={materialDetailType?.res?.commonList.map((item: any) => ({
                  label: item.title, // "Sales" / "Purchase"
                  value: item.id, // ✅ use title instead of id
                }))}
              />
            </Form.Item>

            {/* ✅ Entry Date Range */}
            <Form.Item<EntryLogFilterFormValues>
              label="Entry Date Range"
              name={EntryLogFilterFormField.Date}
            >
              <RangePicker style={{ width: '100%' }} />
            </Form.Item>

            {/* ✅ Exit Date Range */}
            <Form.Item<EntryLogFilterFormValues>
              label="Exit Date Range"
              name={EntryLogFilterFormField.Date1}

            >
              <RangePicker style={{ width: '100%' }} />
            </Form.Item>

            <Form.Item<EntryLogFilterFormValues>
              label="Status"
              name={EntryLogFilterFormField.StatusId}
            >
               <Select
                placeholder="Select Type"
                options={VisitStatus?.res?.commonList.map((item: any) => ({
                  label: item.title, // "Sales" / "Purchase"
                  value: item.id, // ✅ use title instead of id
                }))}
              />
            </Form.Item>

            {screens.lg && (
              <ContentFilters.ButtonsWrapper className="filter_btn">
                <Button type="primary" htmlType="submit">
                  {t('common.buttons.filter', { count: 1 })}
                </Button>
                <Button onClick={onReset}>{t('common.buttons.reset')}</Button>
              </ContentFilters.ButtonsWrapper>
            )}
          </div>
        </StandardItemsWrapper>
      </ContentFilters.FormItemsWrapper>
    </Form>
  );
};
